import { useQuery } from '@tanstack/react-query';

import { VISION_MONITOR_QUERY_KEY } from './useGetVisionMonitorProducts';

import VisionMonitorService, {
  VisionMonitorScope,
} from '@/services/VisionMonitorService';

export function useGetVisionMonitorMetrics(scope: VisionMonitorScope) {
  const { data, isFetching } = useQuery({
    queryKey: [...VISION_MONITOR_QUERY_KEY, 'metrics', scope],
    queryFn: () => VisionMonitorService.getMetrics(scope),
    staleTime: 15 * 1000,
  });

  return {
    metrics: data,
    isLoading: isFetching,
  };
}
